export default function cdnImageLoader({ src, width, quality }) {
  return src
}
